// extracted by mini-css-extract-plugin
var _1 = "ProfileDocumentsWidgetContentSkeleton-moduleProfileDocumentsWidgetContentSkeleton__pxZqb";
var _2 = "ProfileDocumentsWidgetContentSkeleton-moduledivider__zDBkm Divider-moduleDivider__dL3Vg";
export { _1 as "ProfileDocumentsWidgetContentSkeleton", _2 as "divider" }
